export default __webpack_public_path__ + "static/media/1.77881377.png";